import { StyleSheet } from 'aphrodite';
import * as colors from '../../../../web/styles/colors';

export const styles = StyleSheet.create({
	container: {
		maxWidth: '800px',
		margin: '0 auto',
		padding: '24px',
		backgroundColor: colors.white,
		borderRadius: '8px',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '48px',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	label: {
		fontSize: '14px',
		fontWeight: 600,
		color: colors.label,
	},
	textArea: {
		minHeight: '120px',
	},
	objectivePromptArea: {
		minHeight: '150px',
		resize: 'vertical',
	},
	technicalPromptArea: {
		minHeight: '200px',
		resize: 'vertical',
	},
	errorMessage: {
		color: colors.error,
		fontSize: '13px',
		marginTop: '4px',
	},
	actions: {
		display: 'flex',
		gap: '12px',
		justifyContent: 'flex-end',
		marginTop: '32px',
		paddingTop: '24px',
		borderTop: `1px solid ${colors.aceGray}`,
	},
});
